import { Settings } from "@templates"

import PasswordManagement from "./components/PasswordManagement/PasswordManagement"

export default function SettingsSecurityAndAccess() {
    return (
        <Settings.Wrapper title="Security & access">
            <Settings.PageContainer>
                <Settings.PageHeader
                    variant="page-heading"
                    title="Security & access"
                    subtitle="Keep your account secure."
                />

                <Settings.Divider />

                <PasswordManagement />
            </Settings.PageContainer>
        </Settings.Wrapper>
    )
}
